import { useEffect, useRef, useState } from 'react';
import { notifyBookingOpened } from './useChatStream';

const COUNTDOWN_S = 5;

// Counts down, then auto-opens the booking URL in a new tab. The first open
// (auto or manual) alerts Jess once via the backend.
export const useBookingCountdown = (bookingUrl, sessionId) => {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_S);
  const [opened, setOpened] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const notified = useRef(false);

  const markOpened = () => {
    if (!notified.current) {
      notified.current = true;
      notifyBookingOpened(sessionId);
    }
    setOpened(true);
  };
  const markOpenedRef = useRef(markOpened);
  markOpenedRef.current = markOpened;

  useEffect(() => {
    if (opened || blocked) return undefined;
    if (secondsLeft > 0) {
      const t = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
      return () => clearTimeout(t);
    }
    const win = window.open(bookingUrl, '_blank');
    if (win) {
      win.opener = null;
      markOpenedRef.current();
    } else {
      setBlocked(true);
    }
    return undefined;
  }, [secondsLeft, opened, blocked, bookingUrl]);

  let status = `Opening Jess's calendar in ${secondsLeft}s…`;
  if (opened) status = 'Calendar opened in a new tab.';
  if (blocked) status = 'Your browser blocked the pop-up — tap below to book.';

  return { status, markOpened };
};
